import React from "react";
import { Container, Box, Typography, Paper, Grid, Card, CardActionArea, CardContent } from '@mui/material';
import "./MainContentContactUs.css";

// Define a functional component named MainContentContactUs
const MainContentContactUs = () => {
  return (
    <Container id="MainContentSection">
      <Box className="title-main">
        <Typography variant="h3">
          John Deere Operations Center / JDLink Dashboard Support Form
        </Typography>
      </Box>
      <Box className="title-sub-small with-border">
        <Typography variant="h5">
          Request support from the John Deere Global Support Center
        </Typography>
      </Box>
      <Paper className="content-panel inline-links">
        <Typography>
          Please indicate whether you are a John Deere customer or a John Deere dealer/employee.
        </Typography>
        <Grid container spacing={2} justifyContent="center">
          <Grid item xs={12} sm={6}>
            <Card>
              <CardActionArea
                component="a"
                href="https://ccms.deere.com/prweb/MyJohnDeereAuth?pzuiactionzzz=CXtpbn1DdE9RdlRIVTduaFl5TUg5bjZlOTVPdjZNYW1ETi9nMldBNWFydm8waE1DL3gzZXd6Mmo4Vk5KZHk1WHFBVEh6d213WlA1NFZiM2ZkODZycjJCcUZIczd4WnRJaFBqQzY5N21pU0ZoRmRPcXhRZFhwQ2pIZS9SRCtqeGV0LzN6TlhRSnZRNWVPTkt5MThvcmU3ZEVkZmc9PQ=="
                target="_self"
                className="card-link"
              >
                <CardContent>
                  I am a John Deere customer
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
          <Grid item xs={12} sm={6}>
            <Card>
              <CardActionArea
                component="a"
                href="https://ccms.deere.com/prweb/PRServletCustomAuth?pzuiactionzzz=CXtpbn1DdE9RdlRIVTduaFl5TUg5bjZlOTVPdjZNYW1ETi9nMldBNWFydm8waE1EY2tEMWZoOGV3RFVycjNjbVJ5TCtaT20zVWloYmxyQk5SQ04yYXBuZGkwWG9ORVpPcU9xbEovUTNCZnRTZ2F1cz0="
                target="_self"
                className="card-link"
              >
                <CardContent>
                  I am a John Deere dealer/employee
                </CardContent>
              </CardActionArea>
            </Card>
          </Grid>
        </Grid>
      </Paper>
    </Container>
  );
};

// Export the component as the default export
export default MainContentContactUs;